<template>
  <main >
    <home-hero></home-hero>
    <!-- <home-testimonials id="home-testimonials"></home-testimonials> -->
    <home-why id="home-why"></home-why>
    <home-education id="home-education"></home-education>
    <!-- <home-data id="home-data"></home-data> -->
    <home-contest id="home-contest"></home-contest>
    <home-final id="home-final"></home-final>
  </main>
</template>

<script>
import HomeHero from "../components/learnByDoing/HomeHero.vue";

import HomeWhy from "../components/learnByDoing/HomeWhy.vue";
import HomeEducation from "../components/learnByDoing/HomeEducation.vue";
// import HomeData from "../components/learnByDoing/HomeData.vue";
import HomeContest from '../components/learnByDoing/HomeContest.vue';
// import HomeTestimonials from "../components/learnByDoing/HomeTestimonials.vue";
import HomeFinal from "../components/learnByDoing/HomeFinal.vue";

export default {
  components: {
    "home-hero": HomeHero,
    "home-why": HomeWhy,
    "home-education": HomeEducation,
    // "home-data": HomeData,
    "home-contest": HomeContest,
    // "home-testimonials": HomeTestimonials,
    "home-final": HomeFinal,
    
  },
  head() {
    return {
      title: "INVRS - Investment Research, Education and Games.",
      meta:[
        { 
          name: "description",
          content: 'Learn by doing and have fun doing it!'
        },
         { 
          name: "twitter:title",
          content: 'INVRS - Investment Research, Education and Games.'
        },
        { 
          name: "twitter:description",
          content: 'Learn by doing and have fun doing it!'
        },
         { 
          name: "og:title",
          content: 'INVRS - Investment Research, Education and Games.'
        },
        { 
          name: "og:description",
          content: 'Learn by doing and have fun doing it!'
        },
      ]
    }
  }
 
};
</script>

